export const EVENTS = {
  CUSTOM_VIEW_CART: {
    name: "custom_view_cart",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "region",
      "line_items",
      "currency",
      "value",
      "total_discount",
      "subtotal",
      "items",
    ],
  } as const,

  ADD_TO_WISHLIST: {
    name: "add_to_wishlist",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "region",
      "line_items",
      "currency",
      "value",
      "items",
    ],
  } as const,

  CUSTOM_ADD_TO_CART: {
    name: "custom_add_to_cart",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "region",
      "line_items",
      "currency",
      "value",
      "items",
    ],
  } as const,

  CUSTOM_REMOVE_FROM_CART: {
    name: "custom_remove_from_cart",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "region",
      "line_items",
      "currency",
      "value",
      "items",
    ],
  } as const,

  ADD_TO_CART: {
    name: "add_to_cart",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "region",
      "line_items",
      "currency",
      "value",
      "items",
    ],
  } as const,

  REMOVE_FROM_CART: {
    name: "remove_from_cart",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "region",
      "line_items",
      "currency",
      "value",
      "items",
    ],
  } as const,

  ADD_COUPON: {
    name: "add_coupon",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "region",
      "coupon",
      "coupon_message",
      "seller_cod_name",
    ],
  } as const,

  SEARCH: {
    name: "search",
    hasEcommerce: false,
    destinations: ["DataLayer"],
    requiredParams: ["brand", "search_term", "search_found", "search_quantity"],
  } as const,

  SEARCH_ZIPCODE: {
    name: 'search_zipcode',
    hasEcommerce: false,
    destinations: ['DataLayer'],
    requiredParams: ['brand', 'region', 'shippings', 'zipcode', 'flag_pickup'],
  } as const,

  VIEW_PROMOTION: {
    name: "view_promotion",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "region",
      "currency",
      "promotion_name",
      "creative_slot",
      "creative_name",
      // "items",
    ],
  } as const,

  SELECT_PROMOTION: {
    name: "select_promotion",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "region",
      "currency",
      "promotion_name",
      "creative_slot",
      "creative_name",
      // "items",
    ],
  } as const,

  SELECT_CONTENT: {
    name: "select_content",
    hasEcommerce: false,
    destinations: ["DataLayer"],
    requiredParams: ["brand", 'content_type'],
  } as const,

  SELECT_ITEM: {
    name: "select_item",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: ["brand", "region", "items", "line_items"],
  } as const,

  VIEW_ITEM: {
    name: "view_item",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "line_items",
      "currency",
      "value",
      "available_grid",
      "items",
    ],
  } as const,

  CUSTOM_VIEW_ITEM: { // IO STORES
    name: "custom_view_item",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "line_items",
      "currency",
      "value",
      "available_grid",
      "items",
    ],
  } as const,

  VIEW_ITEM_LIST: {
    name: "view_item_list",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: ["region", "brand", "line_items", "items"],
  } as const,

  BEGIN_CHECKOUT: {
    name: "begin_checkout",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: ["brand", "line_items", "currency", "value", "total_discount", "subtotal", "items"],
  } as const,

  CUSTOM_BEGIN_CHECKOUT: {
    name: "custom_begin_checkout",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: ["brand", "line_items", "currency", "value", "total_discount", "subtotal", "items"],
  } as const,

  AUTH_ACTION: {
    name: "auth_action",
    hasEcommerce: false,
    requiredParams: ["region", "method", "type", "brand"],
    destinations: ["DataLayer"],
  } as const,

  ADD_PERSONAL_INFO: {
    name: "add_personal_info",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: ["brand", "pre_filled", "line_items", "currency", "value", "total_discount", "subtotal"],
  } as const,

  CUSTOM_ADD_SHIPPING_INFO: {
    name: "add_shipping_info",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "pre_filled",
      "shipping",
      "shipping_tier",
      "line_items",
      "currency",
      "value",
      "total_discount",
      "subtotal",
      "items"
    ],
  } as const,

  CUSTOM_ADD_PAYMENT_INFO: {
    name: "add_payment_info",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      "brand",
      "pre_filled",
      "line_items",
      "currency",
      "value",
      "total_discount",
      "payment_type",
      "subtotal",
      "items"
    ],
  } as const,

  ORDER_REVIEWED: {
    name: "order_reviewed",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: ["brand", "line_items", "currency", "value", "total_discount", "subtotal", "payment_type"],
  } as const,

  PURCHASE: {
    name: "purchase",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      'brand',
      'shipping_tier',
      'line_items',
      'currency',
      'value',
      'shipping',
      'transaction_id',
      'total_discount',
      'payment_type',
      'seller_cod_name',
      'subtotal',
      'coupon',
      'items'
    ],
  } as const,

  CUSTOM_PURCHASE: {
    name: "custom_purchase",
    hasEcommerce: true,
    destinations: ["DataLayer"],
    requiredParams: [
      'brand',
      'shipping_tier',
      'line_items',
      'currency',
      'value',
      'shipping',
      'transaction_id',
      'total_discount',
      'payment_type',
      'seller_cod_name',
      'subtotal',
      'coupon',
      'items'
    ],
  } as const,

  CUSTOM_USER_INFO: {
    name: 'custom_user_info',
    hasEcommerce: false,
    destinations: ["DataLayer"],
    requiredParams: ['user_info']
  } as const,

  NOTIFY_ME: {
    name: 'notify_me',
    hasEcommerce: false,
    destinations: ["DataLayer"],
    requiredParams: ['brand', 'size', 'item_ref']
  } as const,

  REFINE_RESULTS: {
    name: 'refine_results',
    hasEcommerce: false,
    destinations: ["DataLayer"],
    requiredParams:  ['brand', 'region', 'color', 'price_range', 'size', 'category', 'ordering']
  } as const,

  GRID_SIZE: {
    name: 'grid_size',
    hasEcommerce: false,
    destinations: ["DataLayer"],
    requiredParams:  ['brand', 'slot_per_line']
  } as const
};


type EventName = keyof typeof EVENTS

export type RequiredParamsOf<E extends EventName> = typeof EVENTS[E]['requiredParams'][number]